import React from "react";
import { Link } from "react-router-dom";
import Cards2 from "../cards/Cards2";

const SinglePhase = () => {
  return (
    <>
      <section 
        className="home bg-cover bg-center min-h-screen"
        style={{
          backgroundImage: "url('/assets/images/Monitor.jpg')",
        }}
      >
        <div className="container mx-auto px-4 py-10">
          <div className="heading flex flex-col md:flex-row justify-between items-center mb-8">
            <h3 className="text-8xl font-semibold !text-white drop-shadow ">DashBoard</h3>
            <div className="button-group flex space-x-4 mt-4 md:mt-0">
              <Link 
                to="/singlephase" 
                className="btn px-6 py-2 
                  border border-[#005BAC] 
                  bg-[#005BAC] 
                  text-white 
                  rounded-md 
                  transition duration-300 
                  hover:bg-white 
                  hover:text-[#005BAC] 
                  focus:outline-none 
                  focus:ring-2 
                  focus:ring-[#005BAC] 
                  focus:ring-opacity-50"
              >
                Single Phase
              </Link>
              <Link 
                to="/threephase" 
                className="btn px-6 py-2 
                  border border-[#005BAC] 
                  bg-[#005BAC] 
                  text-white 
                  rounded-md 
                  transition duration-300 
                  hover:bg-white 
                  hover:text-[#005BAC] 
                  focus:outline-none 
                  focus:ring-2 
                  focus:ring-[#005BAC] 
                  focus:ring-opacity-50"
              >
                Three Phase
              </Link>
            </div>
          </div>
          <Cards2 />
        </div>
      </section>
    </>
  );
};

export default SinglePhase;